import { Component, OnInit } from '@angular/core';
import { AppConfig } from '../../../Services/app.config';
import { Router } from '@angular/router';
import { AdminUserType } from '../../../Models/Common';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent implements OnInit {
  appModel: any;
  dt: string = '';
  SelectedTool: string;

  firstLastName: string = '';
  adminCompanyName: string = '';
  isUserSystemAdmin: boolean = false;

  constructor(private readonly router: Router,private sessionStorageService: SessionStorageService) {
    this.sessionStorageService.restoreAdminSessionFromLocalStorage();

    if (localStorage.getItem('AdminUserId') != '' && localStorage.getItem('AdminUserId') != undefined && localStorage.getItem('AdminUserId') != null) {
      this.appModel = AppConfig.settings.ConnectionStrings;
    }

    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.firstLastName = this.sessionStorageService.getAdminFirstLastName();
    this.adminCompanyName = this.sessionStorageService.getAdminCompanyName();

    if (AdminUserType.systemadmin == this.sessionStorageService.getAdminTypeId())
      this.isUserSystemAdmin = true;
  }

  ngOnInit() {
    this.dt = Date();
  }

  logout(): void {
    this.clearSession();
    sessionStorage.removeItem('AdminUserId');
    localStorage.removeItem('AdminUserId');

    sessionStorage.removeItem('AdminUserType');
    localStorage.removeItem('AdminUserType');

    sessionStorage.removeItem('AdminFirstLastName');
    localStorage.removeItem('AdminFirstLastName');

    sessionStorage.removeItem('AdminCompanyName');
    localStorage.removeItem('AdminCompanyName');

    sessionStorage.removeItem('adminTypeId');
    localStorage.removeItem('adminTypeId');

    sessionStorage.removeItem('UserLoginTool');
    localStorage.removeItem('UserLoginTool');

    sessionStorage.removeItem('UserAccessibleTools');
    localStorage.removeItem('UserAccessibleTools');

    // Clear redirect/auth flags so the next login does not reuse prior state.
    sessionStorage.removeItem('LoginStatus');
    this.sessionStorageService.clearAdminReturnUrl();
    this.router.navigateByUrl('/admin/login');
  }

  SetTool(ToolType: string) {
    debugger
    var AccessibleTools = this.sessionStorageService.getUserAccessibleTools();
    if (AccessibleTools.toLowerCase().indexOf(ToolType.toLowerCase()) !== -1) {
      this.SelectedTool = ToolType;
      localStorage.setItem('UserLoginTool', ToolType);
      if (ToolType == 'actionitem')
        this.router.navigate(['admin/trac-it/dashboard']);
      else if (ToolType == 'view 47')
        this.router.navigate(['admin/view47/dashboard']);
      else
        this.router.navigate(['admin/' + this.SelectedTool + '/dashboard']);
    }
    else {
      localStorage.setItem('AccessDeniedTool', ToolType);
      let redirectToTool = ToolType == 'actionitem' ? 'trac-it' : ToolType;
      if (ToolType == 'view 47') {
        let redirectToTool = ToolType == 'view 47' ? 'view47' : ToolType;
        this.router.navigate(['admin/' + redirectToTool + '/access-denied']);
      }
      else {
      this.router.navigate(['admin/' + redirectToTool + '/access-denied']);
      }
    }
  }

  clearSession() {
    sessionStorage.removeItem('saveFilterPageNo');
    sessionStorage.removeItem('saveFilterOrderBy');
    sessionStorage.removeItem('saveFilterWhereCondition');
    sessionStorage.removeItem('saveFilterStateID');
    sessionStorage.removeItem('saveFilterCarrierCategories');

    sessionStorage.removeItem('saveFilterUpDownDeadlineDateCSS');
    sessionStorage.removeItem('saveFilterUpDownSubjectCSS');
    sessionStorage.removeItem('saveFilterUpDownTypeNameCSS');
    sessionStorage.removeItem('saveFilterUpDownCompanyNameCSS');
    sessionStorage.removeItem('saveFilterUpDownStateNameCSS');
    sessionStorage.removeItem('saveFilterUpDownCarrierNameCSS');
    sessionStorage.removeItem('saveFilterUpDownActionChargesCSS');
    sessionStorage.removeItem('saveFilterUpDownIsActionCSS');
    sessionStorage.removeItem('saveFilterUpDownIsInformationOnlyCSS');
    sessionStorage.removeItem('saveFilterIsAscending');
    sessionStorage.removeItem('savePreviousUrl');
    sessionStorage.removeItem('saveFilterOprator');
    sessionStorage.removeItem('saveFilterFromDate');
    sessionStorage.removeItem('saveFilterToDate');
    sessionStorage.removeItem('saveFilterListOfType');
    sessionStorage.removeItem('saveFilterIsActionRequired');
  }
}

